module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Formularz",
      "required": "",
      "error": _vm.errors['form']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz formularz"
    },
    model: {
      value: (_vm.form.form),
      callback: function($$v) {
        _vm.$set(_vm.form, "form", $$v)
      },
      expression: "form.form"
    }
  }, _vm._l((_vm.forms), function(folder) {
    return _c('el-option', {
      key: folder.id,
      attrs: {
        "label": folder.name_pl,
        "value": folder.id
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c92f622"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/FormWidget.vue
// module id = 751
// module chunks = 0